/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DoctorCRMRegisterType = {
  type: 'Enum',
} as const;
